import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { ActivatedRoute } from '@angular/router';
import { Global } from 'asap-crud';
import { DeviceService } from './@core/services/device.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`
})

export class AppComponent implements OnInit {

  constructor(
    public global: Global,
    public activatedRoute: ActivatedRoute,
    public firestorage: AngularFireStorage,
    private deviceService: DeviceService
  ) {
    global.setSessionData('firebase-storage', firestorage.ref('/'));                
  }

  ngOnInit() {
    // Se o usuário já estiver logado (F5 direto em páginas internas), inicializa o dispositivo
    if (sessionStorage.getItem('token') || sessionStorage.getItem('loggedUser')) {
      this.deviceService.initDevice();
    }
  }

}
